angular.module('env.data.repos.users', [])

    .service("usersRepository", function ($q, rest, authService) {
        var _this = this;
        var modelType = "UserModel";
        var modelDefinition = rest.getDefinition(modelType);

        /**
         * Get users
         * @returns {!Promise.<RepresentationModel[]>} Promise of collection of User Models
         */
        _this.getUsers = function () {
            return rest.map(modelDefinition).willReturn(modelType).get();
        };

        /**
         * Get user by id
         * @param {string} id id of the user
         * @returns {!Promise.<RepresentationModel>} Promise of User Model
         */
        _this.getUser = function (id) {
            return rest.map(modelDefinition).map(id).willReturn(modelType, id).get();
        };

        /**
         * Save the user
         * @param {RepresentationModel} user Representation model of the user
         * @returns {!Promise.<RepresentationModel>} Promise of saving success
         */
        _this.saveUser = function (user) {
            return rest.map(modelDefinition).save(user);
        };

        /**
         * Get UserGroups of the user
         * @param {string|RepresentationModel} user User Model or User Id
         * @returns {!Promise.<string[]>} Promise collection of user groups(array of strings)
         */
        _this.getUsersGroups = function (user) {
            return rest.map(modelDefinition).map(user).map("groups").get();
        };

        /**
         * Get centres of the user
         * @param {string|RepresentationModel} user User Model or User Id
         * @returns {!Promise.<RepresentationModel[]>} Promised collection of centres
         */
        _this.getUserCentres = function (user) {
            return rest.map(modelDefinition).map(user).map("centres").willReturn("CentreModel").get();
        };

        /**
         * Get customers of the user
         * @param {string|RepresentationModel} user User Model or User Id
         * @returns {!Promise.<RepresentationModel[]>} Promised collection of customers
         */
        _this.getUserCustomers = function (user) {
            return rest.map(modelDefinition).map(user).map("customers").willReturn("CustomerModel").get();
        };

        /**
         * Get role of the user
         * @param {string|RepresentationModel} user User Model or User Id
         * @returns {!Promise.<Object>} Promised user role (string)
         */
        _this.getUserRole = function (user) {
            return rest.map(modelDefinition).map(user).map("role").get();
        };

        /**
         * Get permissions of the user
         * @param {string|RepresentationModel} user User Model or User Id
         * @returns {!Promise.<Object[]>} Promised collection of user permissions
         */
        _this.getUserPermissions = function (user) {
            return rest.map(modelDefinition).map(user).map("permissions").get();
        };

        //region Current user

        var currentUser;
        authService.events.on('login', function () {
            currentUser = null;
        });
        authService.events.on('loginFailed', function () {
            currentUser = null;
        });
        authService.events.on('logout', function () {
            currentUser = null;
        });

        /**
         * Get current user from the server
         * @param {boolean} [refresh] force reload current user
         * @returns {!Promise.<RepresentationModel>} promise
         */
        _this.getCurrentUser = function (refresh) {
            if (currentUser) {
                if (_.isPromise(currentUser) || !refresh) {
                    return $q.when(currentUser);
                }
            }
            if (!authService.getToken()) {
                var deferred = $q.defer();
                deferred.reject("Not authorized. Auth token is undefined.");
                return deferred.promise;
            }
            currentUser = rest.map(modelDefinition).map("current").willReturn(modelType).get();
            currentUser.then(
                function (user) {
                    currentUser = user;
                    return currentUser;
                },
                function (resp) {
                    currentUser = null;
                    return $q.reject(resp);
                });
            return currentUser;
        };

        /**
         * Save the current user
         * @returns {!Promise.<RepresentationModel>} promise
         */
        _this.saveCurrentUser = function () {
            if (currentUser && currentUser.isRepresentationModel == true) {
                var savePromise = rest.map(modelDefinition).save(currentUser);
                savePromise.then(function (user) {
                    if (user && user.isRepresentationModel == true) {
                        currentUser = user;
                    }
                });
                return savePromise
            }
            throw new Error("Not authorised");
        };

        //endregion

        return _this;
    })

;